import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Bell, Check } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const Notifications = () => {
  const [items, setItems] = useState([]);
  const { t } = useLanguage();
  const load = () => api.get('/notifications').then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const markAll = async () => {
    await api.post('/notifications/read-all');
    load();
  };

  const markOne = async (id) => {
    await api.patch(`/notifications/${id}/read`);
    load();
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-3xl font-bold">{t('notifications.title', 'Notifications')}</h1>
          <p className="text-white/60 mt-1">{t('notifications.subtitle', 'Updates about your orders and account.')}</p>
        </div>
        <Button variant="secondary" size="sm" onClick={markAll} data-testid="notifications-mark-all-button" className="bg-white/[0.06] text-white border border-white/10 hover:bg-white/[0.09]"><Check className="w-4 h-4 mr-1" /> {t('notifications.markAll', 'Mark all read')}</Button>
      </div>

      {items.length === 0 ? (
        <div className="jw-card p-16 text-center mt-6">
          <Bell className="w-8 h-8 text-white/40 mx-auto" />
          <p className="text-white/60 mt-3">{t('notifications.empty', "You're all caught up.")}</p>
        </div>
      ) : (
        <div className="space-y-2 mt-6">
          {items.map(n => (
            <Card key={n.id} className={`jw-card p-4 ${!n.read ? 'border-white/20' : 'opacity-80'}`} data-testid={`notification-${n.id}-card`}>
              <div className="flex items-start gap-3">
                {!n.read && <div className="w-2 h-2 rounded-full jw-gradient-bg mt-2" />}
                <div className="flex-1">
                  <p className="text-white font-semibold">{n.title}</p>
                  <p className="text-white/70 text-sm">{n.message}</p>
                  <p className="text-white/40 text-xs mt-1">{new Date(n.created_at).toLocaleString()}</p>
                </div>
                {!n.read && <button onClick={() => markOne(n.id)} className="text-xs text-white/70 hover:text-white">{t('notifications.markRead', 'Mark read')}</button>}
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default Notifications;
